export default class Pagination {
  public readonly totalCount: number;
  public readonly totalPage: number;
  public readonly currentCount: number;
  public readonly currentPage: number;
  public readonly pageSize: number;
  public readonly isLast: boolean;

  constructor(init: PaginationInitializer) {
    this.totalCount = init.totalCount;
    this.totalPage = init.totalPage;
    this.currentCount = init.currentCount;
    this.currentPage = init.currentPage;
    this.pageSize = init.pageSize;
    this.isLast = init.isLast;
  }
}

export interface PaginationInitializer {
  totalCount: number;
  totalPage: number;
  currentCount: number;
  currentPage: number;
  pageSize: number;
  isLast: boolean;
}
